/**
 * VoidItemDialog Component
 * Dialog for voiding individual items from an order
 */

import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { AlertTriangle } from "lucide-react";

export function VoidItemDialog({ 
  open, 
  onOpenChange, 
  item, 
  reason, 
  onReasonChange, 
  onVoid,
  onCancel
}) {
  const handleCancel = () => {
    onCancel?.();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="void-item-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
            Void Item
          </DialogTitle>
          <DialogDescription>Void &quot;{item?.name}&quot;?</DialogDescription>
        </DialogHeader>
        <Input 
          placeholder="Reason (required)" 
          value={reason} 
          onChange={(e) => onReasonChange(e.target.value)}
          data-testid="void-reason-input"
        />
        <DialogFooter>
          <Button variant="outline" onClick={handleCancel} data-testid="void-cancel-btn">
            Cancel
          </Button>
          <Button 
            variant="destructive" 
            onClick={onVoid} 
            disabled={!reason}
            data-testid="void-confirm-btn"
          >
            Void Item
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
